import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Infinity as InfinityIcon } from "lucide-react";
import Logo from "./Logo";
import { NAV_LINKS } from "../mock/mock";
import { toast } from "sonner";
import api from "../lib/api";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [subscribing, setSubscribing] = useState(false);
  const notify = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubscribing(true);
    try {
      await api.post("/subscribe", { email });
      toast("You're on the list", { description: "We'll ping you before the next drop." });
      setEmail("");
    } catch (err) {
      toast("Try again", { description: err?.response?.data?.detail || "Couldn't subscribe right now." });
    } finally {
      setSubscribing(false);
    }
  };
  return (
    <footer className="relative bg-black border-t border-white/10 mt-8">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo />
          <p className="mt-4 max-w-sm text-sm text-white/55 leading-relaxed">
            Neon-graffiti streetwear built on the infinity mark. Forever. Loyalty.
            No limits. Zero-inventory drops, print-on-demand, shipped worldwide.
          </p>
          <div className="mt-5 flex items-center gap-2 text-neon">
            <InfinityIcon size={22} />
            <span className="font-display tracking-wide">FOREVER · NO LIMITS</span>
          </div>
        </div>

        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-white/50 mb-4">Shop</h4>
          <ul className="space-y-2.5">
            {NAV_LINKS.map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="text-sm text-white/70 hover:text-neon transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-white/50 mb-4">First to know</h4>
          <p className="text-sm text-white/55 mb-3">Get the drop alert before it's gone.</p>
          <form onSubmit={notify} className="flex" data-testid="footer-newsletter-form">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@email.com"
              data-testid="footer-newsletter-input"
              className="flex-1 min-w-0 bg-white/5 border border-white/15 rounded-l-full px-4 py-2.5 text-sm text-white placeholder:text-white/35 focus:outline-none focus:border-neon"
            />
            <button
              type="submit"
              disabled={subscribing}
              data-testid="footer-newsletter-submit"
              className="bg-neon text-black font-bold text-xs uppercase tracking-widest px-4 rounded-r-full hover:brightness-95 transition disabled:opacity-60"
            >
              {subscribing ? "..." : "Notify"}
            </button>
          </form>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">© {new Date().getFullYear()} Always-N-Anytime. All rights reserved.</p>
          <nav className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1" data-testid="footer-legal-links">
            <Link to="/shipping-returns" className="text-xs text-white/50 hover:text-neon transition-colors">Shipping & Returns</Link>
            <Link to="/faq" className="text-xs text-white/50 hover:text-neon transition-colors">FAQ</Link>
            <Link to="/terms" className="text-xs text-white/50 hover:text-neon transition-colors">Terms</Link>
            <Link to="/privacy" className="text-xs text-white/50 hover:text-neon transition-colors">Privacy</Link>
          </nav>
          <p className="text-xs text-white/40">Print-on-demand · Ships worldwide</p>
        </div>
      </div>
    </footer>
  );
}
